import config from '../config';

// Utility function to get the correct API base URL
export function getApiBase(): string {
  return config.API_BASE;
}

// Helper function for making API requests with proper error handling
export async function apiRequest(endpoint: string, options?: RequestInit) {
  const apiBase = getApiBase()
  const url = `${apiBase}${endpoint}`
  
  console.log(`🌐 API Request: ${url}`)
  
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    },
    ...options
  })
  
  if (!response.ok) {
    throw new Error(`API Error: ${response.status} ${response.statusText}`)
  }
  
  return response.json()
} 